import './App.scss';
import FindInStoreModal from './components/FindInStoreModal';
import { useDispatch, useSelector } from 'react-redux'
import { openPopup, closePopup } from './redux/reducers/popupDataSlice'
import { useEffect } from 'react';
import { GOOGLE_API_KEY } from './utils/costants';
import { getDefaultMapLink } from './utils/Utils';
import ReactDOM from 'react-dom';
import i18n from './i18n';

const App = ({ config }) => {

  const storeDispatcher = useDispatch();

  const getLanguageFromStore = (storeId, langId) => {
      if (storeId === "10851" && langId === "-1") return 'en';
      if (storeId === "10852" && langId === "-24") return 'en';
      if (storeId === "10851" && langId === "-50") return 'es';
      if (storeId === "10852" && langId === "-25") return 'fr';
      return 'en'; // fallback
    };
    
  useEffect(() => {
    setComponentLanguage(config, getLanguageFromStore);
    loadGoogleApi();
    const mapLink = getDefaultMapLink(config.data.storeId);
    storeDispatcher(openPopup(mapLink));
    toggleLockPageScroll(true);
  }, []);

  const onClose = () => {
    toggleLockPageScroll(false);
    storeDispatcher(closePopup());
    // Unmount FIS
    ReactDOM.unmountComponentAtNode(document.querySelector(config.selector));
  };

  const toggleLockPageScroll = lock => {
    document.querySelectorAll('html,body').forEach(elem => {
        elem.style.overflow = lock ? 'hidden' : '';
        elem.style.position = lock ? 'fixed' : '';
        elem.style.height = lock ? '100%' : '';
    });
};

  return (
    <div className='app-find-store container-fluid'>
      <div> <FindInStoreModal onClose={onClose} config={config} /></div>
    </div>
  );

}

export default App;


function setComponentLanguage(config, getLanguageFromStore) {
  if ( (config.data.storeId != null && config.data.storeId != "") && (config.data.langId != null && config.data.langId != "")) {
    i18n.changeLanguage(getLanguageFromStore(config.data.storeId, config.data.langId));
  }
}

function loadGoogleApi() {
  const script = document.createElement("script");
  script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&callback=initMap`;
  script.async = true;
  script.defer = true;
  window.initMap = function () {
  };
  document.body.appendChild(script);
}